import React from 'react';
import {Tab, Tabs} from '@mui/material';

interface TabsComponentProps {
  ariaLabel?: 'primary' | 'secondary';
  handleChange?: (value: number) => void;
  tabs: string[];
  value?: number;
  variant?: 'fullWidth' | 'standard';
}

const TabsComponent = (props: TabsComponentProps) => {
  const {ariaLabel = 'primary', handleChange, tabs, value = 0, variant = 'standard'} = props;

  return (
    <Tabs aria-label={ariaLabel} variant={variant} onChange={(evt, newValue) => handleChange?.(newValue)} value={value}>
      {tabs.map((tabs, index) => (
        <Tab
          key={`Tab ${index} - ${tabs}`}
          label={tabs}
          value={index}/>
      ))}
    </Tabs>
  );
};

export default TabsComponent;
